import { $ } from "@olmokit/dom";
import Olmoforms from "@olmokit/core/olmoforms/feedback";
import Dependency from "@olmokit/core/olmoforms/dependency";
import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import "@olmokit/core/forms/checkbox";
import "@olmokit/core/forms/textarea/filled";
import { dataLayerForm, salesforceCommunication } from "components/Datalayer";
import "./index.scss";
import axios from 'axios';
import { globalConf } from "@olmokit/core/data";
import { post } from "@olmokit/core/fragments/ajax";

/**
 * Component: FormProfessional2
 *
 */
export function FormProfessional2() {

  let ip = '';

  const olmoform = Olmoforms(".Contacts:professional2", {
    before: async (formData) => {
      console.log('step 1');
      console.log(formData);

      const $localcheck = $('#of-3-localcheck');
      if ($localcheck.value !== '') {
        console.log('stopped');
        olmoform.boot(); // Halts submission
        return Promise.reject("Local check failed");
      }

      try {
        console.log('detectip');
        const { data } = await post('detectip', {
          data: { item: '$minimal' }
        });
        console.log('step 2');
        ip = data;

        const token = await grecaptcha.execute('6LfzBrYrAAAAAPZEBP-w_GyN9AcH18mZA2w6i4NO', { action: 'submit' });
        console.log('step 3');

        await axios.post(globalConf.cmsApiUrl + '/recaptcha', {
          token,
          ip,
        });

        console.log('step 4');
        console.log('recaptcha done');
      } catch (error) {
        console.error('step ERROR', error);
        olmoform.boot(); // Prevents submit if reCAPTCHA or detectip fails
        return Promise.reject("Hook before failed");
      }

      console.log('step 5 (end)');

    },
    sent: (response) => {
      const { data, formData } = response;
      console.log('sent', response);
      console.log('step 6');      
      dataLayerForm("form sent", data.form.body, "Form Professional", $('#of-2-profession').value, $('#of-2-requesttype').value, "2");

      axios.post(globalConf.cmsApiUrl + '/formscompiler', {
        email: formData['email'],
        ip: ip,
      })
        .then(() => {
          console.log('step 7');
          console.log('formscompiler done');
        })
        .catch((error) => {
          console.log(error);
        });

      salesforceCommunication(data.form.body, "Form Professional", $('#of-2-profession').value, $('#of-2-requesttype').value);
      console.log('data', data);
      const nav = $(".Contacts:nav");
      nav.style.display = 'none';
    }
  });

  FormsInputMaterial();
  FormsSelectMaterial();
  Dependency(".Contacts:professional2");

  return {
    destroy() {
      olmoform.destroy();
    },
  };

}
